const route = [
    {
        path: '/activity/calligraphy/index', //素质驿站书法宣传页
        component: function (resolve) {
            require(['VIEWS/activity/calligraphy/index.vue'], resolve);
        }
    }
]
export default route
